module.exports = __webpack_public_path__ + "img/exportWord.8f5c01e4.svg";